import BaseCrudService from './baseCrud.service'

class ApartmentService extends BaseCrudService {
  constructor () {
    super('apartment', {
      id: false,
      project_id: false,
      data: {},
      status: 1,
      created_by: 1
    })
  }

  linkProject (itemId, requestId, ...callbacks) {
    return this.constructor.get(this.endpoints().link.replace('{:id}', itemId).replace('{:projectId}', requestId), {}, ...callbacks)
  }

  unlinkProject (itemId, requestId, ...callbacks) {
    return this.constructor.get(this.endpoints().unlink.replace('{:id}', itemId).replace('{:projectId}', requestId), {}, ...callbacks)
  }
}

export default ApartmentService
